module.exports = __webpack_public_path__ + "media/rhythm1.c067cd4b.wav";